/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { MailRequirementSetting, SystemVarsRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { OfficeData } from '@gh/common-shared-data';
import { Observable } from 'rxjs';
import { SystemVariablesContactsDetails } from './model/system-vars-contacts-details.model';

@Injectable()
export class SystemVarsContactsTabBusinessService implements InitViewService {
  private office: OfficeData;

  constructor(private restService: SystemVarsRestService,
              private userContext: BuilderUserContext,
              private dictionaryService: DictionaryService) {
    this.office = <OfficeData>this.userContext.office;
  }

  initView(): any {

    return {
      email: this.dictionaryService.getByEnum(MailRequirementSetting),
      contactSettings: this.restService.getContactSettings(),
    };
  }

  update(contactDetails: SystemVariablesContactsDetails): Observable<SystemVariablesContactsDetails> {
    return this.restService.updateContactSettings(contactDetails);
  }
}
